/**
 * Tracking Events
 * This file is used to track events on the LocationHero app.
 * It listens to custom events and sends the data to Shopify's analytics.
 * All data should be prepared and sent in the format that Shopify's analytics expects.
 *
 * Namespace: ctracking
 */
document.addEventListener('ctracking:location-added', function (event) {
  const eventData = event.detail;

  const ecommerceData = {
    currency: eventData.currency,
    value: eventData.value,
    items: [
      {
        item_name: eventData.location_name,
        item_id: eventData.locationId,
        price: eventData.value,
        currency: eventData.currency,
        item_category: eventData.item_category,
        quantity: 1,
        item_brand: 'LocationHero',
      },
    ],
  };

  Shopify.analytics.publish('locationAdded', ecommerceData);
  console.log('Ecommerce data', ecommerceData);
});

document.addEventListener('ctracking:request-details', function (event) {
  const eventData = event.detail;

  let totalValue = 0;
  eventData.requestData.forEach((request) => {
    totalValue += request.value;
  });

  const ecommerceData = {
    page_location: window.location.href,
    currency: eventData.requestData[0].currency,
    value: totalValue,
    items: eventData.requestData.map((request) => {
      return {
        item_name: request.location_name,
        item_id: request.locationId,
        price: request.value,
        currency: request.currency,
        item_category: request.item_category,
        quantity: 1,
        item_brand: 'LocationHero',
      };
    }),
  };

  Shopify.analytics.publish('requestsViewed', ecommerceData);
});

document.addEventListener('ctracking:request-step', function (event) {
  Shopify.analytics.publish('requestsCheckoutStep', event.detail);
});

document.addEventListener('ctracking:request-success', function (event) {
  const eventData = event.detail;

  let totalValue = 0;
  eventData.requestData.forEach((request) => {
    totalValue += request.value;
  });

  const ecommerceData = {
    page_location: window.location.href,
    currency: eventData.requestData[0].currency,
    customer: eventData.customer,
    value: totalValue,
    items: eventData.requestData.map((request) => {
      return {
        item_name: request.location_name,
        item_id: request.locationId,
        price: request.value,
        currency: request.currency,
        item_category: request.item_category,
        quantity: 1,
        item_brand: 'LocationHero',
      };
    }),
  };

  Shopify.analytics.publish('requestsSubmitted', ecommerceData);
});

document.addEventListener('ctracking:confirm-offer', function (event) {
  const eventData = event.detail;

  const ecommerceData = {
    page_location: window.location.href,
    customer: eventData.customer,
    currency: eventData.currency,
    value: eventData.netValue,
    offerId: eventData.offerId,
    requestId: eventData.requestId,
    eventName: eventData.event,
    eventAction: eventData.eventAction,
    eventCategory: eventData.eventCategory,
  };

  Shopify.analytics.publish('offerConfirmed', ecommerceData);
});

document.addEventListener('ctracking:decline-offer', function (event) {
  const eventData = event.detail;

  const ecommerceData = {
    page_location: window.location.href,
    customer: eventData.customer,
    currency: eventData.currency,
    value: eventData.netValue,
    offerId: eventData.offerId,
    requestId: eventData.requestId,
    reason: eventData.declineMsg,
    eventName: eventData.event,
    eventAction: eventData.eventAction,
    eventCategory: eventData.eventCategory,
  };

  Shopify.analytics.publish('offerDeclined', ecommerceData);
});

document.addEventListener('ctracking:checkout-initiated', function (event) {
  const eventData = event.detail;

  const ecommerceData = {
    page_location: window.location.href,
    customer: eventData.customer,
    currency: eventData.currency,
    value: eventData.netValue,
    offerId: eventData.offerId,
    requestId: eventData.requestId,
    eventName: eventData.event,
    eventAction: eventData.eventAction,
    eventCategory: eventData.eventCategory,
  };

  Shopify.analytics.publish('offerCheckoutInitiated', ecommerceData);
});

document.addEventListener('vendor-registration:submit', function (event) {
  const eventData = event.detail;

  const ecommerceData = {
    email: eventData.email,
    first_name: eventData.name,
    last_name: eventData.last_name,
    phone: eventData.phone,
    locale: eventData.locale,
    ownership: eventData.ownership,
    user_type: eventData.user_type,
    signup_date: eventData.signup_date,
  };

  Shopify.analytics.publish('vendorRegistration', ecommerceData);

  // Send a custom klaviyo event
  // check if klaviyo exists
  if (typeof klaviyo === 'undefined') return;

  // First run identity tracking
  const identityProperties = ecommerceData;

  //Optionally include a callback function
  function onIdentifyCompleteCallback() {
    klaviyo.push(['track', 'Vendor Registration', ecommerceData]);
  }

  // Identify user then send custom event for the identified user
  klaviyo.identify(identityProperties, onIdentifyCompleteCallback);
});

document.addEventListener('ctracking:checkout-completed', function (event) {
  const eventData = event.detail;

  Shopify.analytics.publish('stripeCheckoutCompleted', eventData);
});
